<template>
  <ValidationProvider v-slot="{ valid, errors }" :name="$attrs.name" :rules="rules">
    <b-form-group>
      <b-form-radio-group
        v-model="innerValue"
        :options="$attrs.options ? $attrs.options.list : []"
        :value-field="$attrs.options ? $attrs.options.valueField : 'item'"
        :text-field="$attrs.options ? $attrs.options.textField : 'name'"
        :disabled-field="$attrs.options ? $attrs.options.disabledField : 'disabled'"
        :stacked="$attrs.options ? $attrs.options.stacked : false"
        :state="errors[0] ? false : (valid ? true : null)"
        :aria-describedby="`${$attrs.name}-live-feedback`"
      >
        <slot />
      </b-form-radio-group>
    </b-form-group>
    <b-form-invalid-feedback :id="`${$attrs.name}-live-feedback`">{{ errors[0] }}</b-form-invalid-feedback>
  </ValidationProvider>
</template>


<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
      default: '',
    }
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('update-value', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
